<template>
  <!-- 基本信息 -->
  <div class="w-full h-full pb-5">
    <el-row class="w-full custom-height overflow-y-auto overflow-x-hidden p-5">
      <el-col :span="24">
        <div>
          <el-collapse v-model="activeNames">
            <el-collapse-item name="baseInfo">
              <template slot="title">
                <span class="text-14px">基本信息</span>
              </template>
              <el-form ref="formBase" label-width="150px" :rules="rules" :model="formData">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="承包商单位名称" prop="orgName">
                      <el-input
                        size="small"
                        v-model="formData.orgName"
                        placeholder="请输入承包商单位名称"
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="承包商单位简称" prop="orgShortName">
                      <el-input
                        size="small"
                        v-model="formData.orgShortName"
                        placeholder="请输入承包商单位简称"
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="承包商单位负责人" prop="orgLeader">
                      <el-input
                        size="small"
                        v-model="formData.orgLeader"
                        placeholder="请输入承包商单位负责人"
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="联系电话" prop="phoneNumber">
                      <el-input
                        size="small"
                        v-model="formData.phoneNumber"
                        placeholder="请输入联系电话"
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="身份证号码" prop="idCard">
                      <el-input
                        size="small"
                        v-model="formData.idCard"
                        :disabled="disabled"
                        placeholder="请输入身份证号码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="邮箱" prop="email">
                      <el-input
                        size="small"
                        v-model="formData.email"
                        :disabled="disabled"
                        placeholder="请输入邮箱"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- <el-form-item label="所属专业" prop="ownerdSpecialtyId">
                      <el-select
                        v-model="formData.ownerdSpecialtyId"
                        filterable
                        placeholder="请选择所属专业"
                        clearable
                        :disabled="disabled"
                        class="w-full"
                      >
                        <el-option
                          v-for="item in specialtyList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item label="项目内容" prop="projectContent">
                      <el-input
                        size="small"
                        v-model="formData.projectContent"
                        placeholder="请输入项目内容"
                        maxlength="500"
                        :disabled="disabled"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="开始在厂时间" prop="startAtTheFactoryTime">
                      <el-date-picker
                        v-model="formData.startAtTheFactoryTime"
                        type="date"
                        class="!w-full"
                        placeholder="请选择开始在厂时间"
                        :disabled="disabled"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="结束在厂时间" prop="endAtTheFactoryTime">
                      <el-date-picker
                        v-model="formData.endAtTheFactoryTime"
                        type="date"
                        class="!w-full"
                        placeholder="请选择结束在厂时间"
                        :disabled="disabled"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
            <el-form ref="apiForm" label-width="140px" :model="apiForm" v-if="status !== 0">
              <el-row :gutter="10">
                <el-collapse-item
                  v-for="(typeItems, index) in sortAptitudeList"
                  :key="index"
                  :name="typeItems.directoryName"
                >
                  <template slot="title">
                    <div class="text-14px">
                      {{ typeItems.directoryName }}
                      <span class="text-12px"> (请将相关资质统一汇总到pdf文件中,并上传)</span>
                    </div>
                  </template>

                  <el-col :span="8">
                    <h3 class="font-bold text-sm">
                      <span v-show="!!typeItems.isRequired" class="text-small text-red-500 pr-2px"
                        >*</span
                      >文件上传
                    </h3>
                    <el-form-item label-width="0px" :prop="`filed${index + 1}`">
                      <form-upload v-model="typeItems.fileResourceId" :disabled="disabled" />
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="8"
                    :key="ind"
                    v-for="(item, ind) in typeItems.child"
                    class="mb-20px"
                  >
                    <div class="mb-10px font-bold text-sm">
                      <span v-show="!!item.isRequired" class="text-small text-red-500 pr-2px"
                        >*</span
                      >{{ `${ind + 1}.${item.title}` }}
                    </div>
                    <div class="mb-10px">{{ item.titleContent }}</div>
                    <el-form-item label="是否提供" :prop="item.configurationId">
                      <el-radio-group
                        v-model="apiForm[item.configurationId]"
                        @input="(e) => ridioInput(e, `${item.configurationId}`)"
                      >
                        <el-radio :label="true" disabled>是</el-radio>
                        <el-radio :label="false" disabled>否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      v-if="!apiForm[item.configurationId]"
                      :prop="`${item.configurationId}explain`"
                      label="说明"
                      :rules="[{ required: true, message: '说明不能为空', trigger: 'blur' }]"
                    >
                      <el-input
                        class="!w-400px"
                        disabled
                        type="textarea"
                        v-model="apiForm[`${item.configurationId}explain`]"
                        placeholder="请输入说明"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-collapse-item>
              </el-row>
            </el-form>
            <el-collapse-item name="rateInfo" v-if="rateInfo && rateInfo.length > 0">
              <template slot="title">
                <span>评价信息</span>
              </template>
              <div v-for="(item, index) in rateInfo" :key="index" class="mb-5">
                <div class="flex justify-between items-center">
                  <div class="flex items-center">
                    <span class="mr-4 text-sm custom-title">{{ item.userName }}</span>
                    <el-rate
                      show-text
                      disabled
                      class="custom-title"
                      v-model="item.evaluationlevel"
                    ></el-rate>
                  </div>
                  <div class="text-gray-400 text-sm">
                    {{ dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss') }}
                  </div>
                </div>
                <p class="text-sm custom-title" v-if="item.evaluationOpinions">
                  {{ item.evaluationOpinions }}
                </p>
              </div>
            </el-collapse-item>
            <el-collapse-item name="outInfo" v-if="status === 2">
              <template slot="title">
                <span>退场单</span>
              </template>
              <form-upload
                v-if="formData.exitRecordFormFileId"
                v-model="formData.exitRecordFormFileId"
                :disabled="disabled"
              ></form-upload>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
    </el-row>
    <div class="w-full flex justify-center items-center mt-5 mb-5">
      <el-button type="primary" size="small" @click="handleAudit" v-if="pageType === 'approve'"
        >审批</el-button
      >
      <el-button @click="$emit('back')" size="small" v-if="pageType">取消</el-button>
    </div>

    <!-- 审批弹窗 -->
    <el-dialog
      v-if="visible"
      :close-on-click-modal="false"
      title="审批"
      :visible.sync="visible"
      class="small-dialog"
      v-dialogDrag
      append-to-body
    >
      <el-form ref="checkResultForm" label-width="150px" :model="checkResultForm">
        <el-form-item
          label="审批结果"
          prop="isPass"
          :rules="[{ required: true, message: '请选择审批结果', trigger: 'blur' }]"
        >
          <el-radio-group v-model="checkResultForm.isPass">
            <el-radio :label="true">审批通过</el-radio>
            <el-radio :label="false">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="审批意见"
          prop="approve"
          :rules="[{ required: true, message: '请输入审批意见', trigger: 'blur' }]"
        >
          <el-input
            v-model="checkResultForm.approve"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="handleSaveResult" :loading="cardLoading"
          >保存</el-button
        >
        <el-button size="small" @click="cancelResult">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { ContractorApi, ValuativeInformationApi } from '@wiz-api/contractor-management'
import { SpecialtyApi } from '@wiz-api/team-management'
import FormUpload from '@/components/safety/FileUpload/FormUpload'

const contractorApi = new ContractorApi()
const valuativeInformationApi = new ValuativeInformationApi()
const specialtyApi = new SpecialtyApi()

export default {
  name: 'base-info',
  components: {
    FormUpload,
  },
  props: {
    taskId: {
      type: String,
      default: '',
    },
    contractId: {
      type: String,
    },
    pageType: {
      type: String,
      default: '',
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
        return
      }
      const reg = /^1[3-9]{1}[0-9]{9}$/
      if (!reg.test(value)) {
        callback(new Error('请填写正确的手机号'))
        return
      }
      callback()
    }

    // 身份证验证
    const validateCard = (rule, value, callback) => {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!value) {
        callback()
      } else if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的身份证号码'))
      }
    }
    return {
      visible: false,
      cardLoading: false,
      checkResultForm: {
        isPass: true,
        approve: '',
      },
      disabled: true,
      status: null,
      activeNames: ['baseInfo', 'rateInfo', 'outInfo'],
      rateInfo: [],
      apiForm: {},
      aptitudeList: [],
      specialtyList: [],
      formData: {
        orgName: '',
        projectContent: '',
        orgShortName: '',
        orgLeader: '',
        phoneNumber: '',
        idCard: '',
        email: '',
        exitRecordFormFileId: undefined,
      },
      rules: {
        orgName: [{ required: true, message: '请输入承包商单位名称', trigger: ['blur', 'change'] }],
        orgShortName: [
          { required: true, message: '请输入承包商单位简称', trigger: ['blur', 'change'] },
        ],
        orgLeader: [
          { required: true, message: '请输入承包商单位负责人', trigger: ['blur', 'change'] },
        ],
        // ownerdSpecialtyId: [
        //   { required: true, message: '请选择所属专业', trigger: ['blur', 'change'] },
        // ],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: ['blur', 'change'],
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        idCard: [{ required: false, validator: validateCard, trigger: ['blur', 'change'] }],
      },
    }
  },
  created() {
    this.getSpecialtyList()
    // 获取承包商详细信息
    this.getContractDetail()
  },
  computed: {
    sortAptitudeList() {
      const list = this.aptitudeList.reduce((pre, item, index) => {
        const child = pre.find((i) => {
          return i.directoryName === item.directoryName
        })
        if (!child || child === -1) {
          const fileResourceId = item.fileId
          pre.push({
            directoryName: item.directoryName,
            child: [item],
            fileResourceId,
            isRequired: item.isRequired,
          })
        } else {
          child.child.push(item)
        }
        return pre
      }, [])

      return list
    },
  },
  methods: {
    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
        this.specialtyList.unshift({ id: '00000000-0000-0000-0000-000000000000', name: '无专业' })
      }
    },
    // 取消审批
    cancelResult() {
      this.visible = false
    },
    handleAudit() {
      this.visible = true
      this.currentContractor = {
        id: this.formData.id,
        orgName: this.formData.orgName,
      }
    },
    // 审批
    handleSaveResult() {
      this.$refs.checkResultForm.validate(async (valid) => {
        if (valid) {
          this.cardLoading = true
          const [err, res] = await contractorApi.exitApprove({
            body: {
              id: this.currentContractor.id,
              taskId: this.taskId,
              ...this.checkResultForm,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '审批成功',
              type: 'success',
            })
            this.visible = false
            this.$emit('save')
          }
          this.cardLoading = false
        }
      })
    },
    setValue(result) {
      const form = {}
      result.forEach((item) => {
        // 新增默认所有都有
        form[item.configurationId] = !!item.isProvided
        form[`${item.configurationId}explain`] = item.description
      })
      this.apiForm = form
    },
    ridioInput(value, id) {
      if (value) {
        this.apiForm[id] = ''
      }
    },
    // 获取承包商指引配置文件数据
    async getGuidanceConfigurationList() {
      const [error, res] = await contractorApi.profileTemplateGuidanceConfiguration({
        contractorId: this.contractId,
      })
      if (!error) {
        res.forEach((item) => {
          this.activeNames.push(item.directoryName)
        })
        this.aptitudeList = res
        this.setValue(res)
      }
    },
    // 查询承包商评价信息
    async getEvaluateInfo() {
      const [error, res] = await valuativeInformationApi.valuativeInformationList({
        relatedId: this.contractId,
      })
      if (!error) {
        this.rateInfo = res || []
      }
    },
    // 获取承包商信息
    async getContractDetail() {
      const [error, res] = await contractorApi.get(this.contractId)
      if (!error) {
        this.formData = res
        this.status = this.formData.status
        if (this.status !== 0) {
          this.getGuidanceConfigurationList()
          // 查询承包商评价信息
          this.getEvaluateInfo()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider__text {
  font-weight: bold;
  font-size: 16px;
}

::v-deep .el-card__body {
  height: 100%;
  padding-bottom: 0 !important;
}

::v-deep .custom-height {
  height: calc(100% - 40px);
}

.custom-title {
  color: var(--textColor);
}
</style>
